<script setup>
defineProps({
    embedId: { type: String, default: null },
});
</script>

<template>
    <div
        v-if="embedId"
        class="w-full max-w-[1120px] rounded-[var(--radius)] overflow-hidden aspect-video">
        <iframe
            :src="`https://www.youtube.com/embed/${embedId}?rel=0`"
            class="w-full h-full"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen />
    </div>
</template>
